import React from 'react';
import { formatDateTime } from '../../utils/dateUtils';
import { Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { LANDING_ROUTE } from '../../utils/roleLanding';
import { useAuth } from '../../context/AuthContext';
import { displayUsername } from '../../utils/userUtils';

const ImpersonationBanner: React.FC = () => {
    const { isImpersonating, user, exitImpersonation } = useAuth();
    const navigate = useNavigate();

    if (!isImpersonating) return null;

    const expiresAt = user?.expiresAt
        ? formatDateTime(user.expiresAt * 1000)
        : 'unknown';

    const handleExit = async () => {
        await exitImpersonation();
        navigate(LANDING_ROUTE);
    };

    return (
        <Alert
            severity="warning"
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                zIndex: 9999,
                borderRadius: 0,
                alignItems: 'center',
            }}
            action={
                <Button color="inherit" size="small" variant="outlined" onClick={handleExit}>
                    Exit Impersonation
                </Button>
            }
        >
            You are impersonating <strong>&nbsp;{user?.name || displayUsername(user?.username)}&nbsp;</strong> — Session expires {expiresAt}
        </Alert>
    );
};

export default ImpersonationBanner;
